const MAX_UNDO_COUNT = 50;

/**
 * class for tracking level eidtor
 */
export class LevelEditorStateTracker {
  /**
   * constructor
   * @param {Object} initialStateObj
   */
  constructor(initialStateObj) {
    this._initialStateJSON = JSON.stringify(initialStateObj);
    this._undoList = [this._initialStateJSON];
    this._redoList = [];
  }

  /**
   * add a level data state
   * @param {Object} stateObj
   */
  addState(stateObj) {
    const stateChanged = !this._matchesPreviousState(stateObj);
    if (stateChanged) this._undoList.push(JSON.stringify(stateObj));
    this._redoList.length = 0; // clear redos
    if (this._undoList.length > MAX_UNDO_COUNT + 1) this._undoList.shift();
    this._logStatus();
  }

  /**
   * check if a stateObj matches the last recorded redosAvailable
   * @param {boolean} stateObj
   */
  _matchesPreviousState(stateObj) {
    if (this._undoList.length === 0) return false;
    const prevStateObj = this._undoList[this._undoList.length - 1];
    return prevStateObj === JSON.stringify(stateObj);
  }

  /**
   * get undo state Object
   * @returns {Object}
   */
  getUndoState() {
    if (this._undoList.length > 1) {
      const stateJSON = this._undoList.pop();
      this._redoList.push(stateJSON);
    } else {
      this._logStatus();
      return JSON.parse(this._undoList[0]);
    }
    this._logStatus();
    return JSON.parse(this._undoList[this._undoList.length - 1]);
  }

  /**
   * get redo state Object
   * @returns {Object}
   */
  getRedoState() {
    if (this._redoList.length === 0) return null;
    const stateJSON = this._redoList.pop();
    this._undoList.push(stateJSON);
    this._logStatus();
    return JSON.parse(stateJSON);
  }

  /**
   * true if the undo states are available
   * @param {boolean}
   */
  get undosAvailable() {
    return this._undoList.length > 1;
  }

  /**
   * true if the redo states are available
   * @param {boolean}
   */
  get redosAvailable() {
    return this._redoList.length > 0;
  }

  /**
   * get undo status text
   * @returns {string}
   */
  getUndoStatusString() {
    return `${this._undoList.length - 1}/${MAX_UNDO_COUNT}`;
  }

  /**
   * log status of state tracking
   */
  _logStatus() {
    console.log(`LevelEditorStateTracker, historySteps: ${this._undoList.length}, redoSteps: ${this._redoList.length}`);
  }
}
